import { useEffect, useState } from 'react'

type OptionsProps = {
  onOpen?: () => unknown
  onClose?: () => unknown
}

export const useDisclosure = (initialState = false, options?: OptionsProps) => {
  const onOpen = options?.onOpen
  const onClose = options?.onClose

  const [isOpen, setIsOpen] = useState(initialState)

  useEffect(() => {
    if (isOpen !== initialState) {
      setIsOpen(initialState)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState])

  const open = () => {
    setIsOpen(true)
    if (typeof onOpen === 'function') {
      onOpen()
    }
  }

  const close = () => {
    setIsOpen(false)
    if (typeof onClose === 'function') {
      onClose()
    }
  }

  const toggle = () => (isOpen ? close() : open())

  return { isOpen, open, close, toggle }
}
